// Imperative notifications — notification.success(message, { title }) from anywhere.

const DEFAULT_DURATION_MS = 5000;

// One per Alert variant, by the same names, so the host passes them straight through.
export const NOTIFICATION_VARIANTS = Object.freeze({
  info: 'info',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
});

let items = [];
let nextId = 0;
const listeners = new Set();

const publish = () => listeners.forEach((listener) => listener());

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// The same array reference is returned until something changes (useSyncExternalStore).
const getSnapshot = () => items;

const dismiss = (id) => {
  items = items.filter((item) => item.id !== id);
  publish();
};

// `message` is the body line; `title` is the optional bold line above it.
const show =
  (variant) =>
  (message, { title, duration = DEFAULT_DURATION_MS } = {}) => {
    if (!message && !title) return null;
    nextId += 1;
    const id = nextId;
    items = [...items, { id, variant, title, message }];
    publish();
    if (duration) setTimeout(() => dismiss(id), duration);
    return id;
  };

export const notification = {
  info: show(NOTIFICATION_VARIANTS.info),
  success: show(NOTIFICATION_VARIANTS.success),
  warning: show(NOTIFICATION_VARIANTS.warning),
  danger: show(NOTIFICATION_VARIANTS.danger),
  error: show(NOTIFICATION_VARIANTS.danger),
  dismiss,
  subscribe,
  getSnapshot,
};
